
































import { defineComponent, ref } from '@vue/composition-api';
import TooltipInfo from '../tooltip-info/index.vue';

const name = 'ttam-expansion-panel';
export default defineComponent({
  name,
  components: {
    TooltipInfo,
  },
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    desc: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    labelTip: {
      type: String,
      default: '',
    },
    labelClass: {
      type: String,
      default: '',
    },
    titleClass: {
      type: String,
      default: '',
    },
    contentClass: {
      type: String,
      default: '',
    },
    highlightTitle: {
      type: Boolean,
      default: false,
    },
    labelTipHintHover: {
      type: String,
      default: '',
    },
    showExpansionIcon: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const curActive = ref(props.value);
    const onExpand = () => {
      curActive.value = !curActive.value;
      emit('input', curActive.value);
      emit('expand', curActive.value);
    };

    return {
      name,
      curActive,
      onExpand,
    };
  },
});
